import type {AdminSearchInfo} from 'src/openapi/admin/models/AdminSearchInfo';

const getExactDataItem = (items: Array<AdminSearchInfo>, searchByEmail: string) => {
    return items.find(e => {
        return e.userInfo.email === searchByEmail;
    });
};


type SelectUserByEmail = (params: {data: Array<AdminSearchInfo>, searchByEmail: string}) => AdminSearchInfo;
export const selectUserByEmail: SelectUserByEmail = ({data, searchByEmail}) => {
    if (data.length) {
        const exactDataItem = getExactDataItem(data, searchByEmail);
        if (exactDataItem && exactDataItem?.userInfo.email === searchByEmail) {
            return exactDataItem;
        }
    }
    return {
        userInfo: {
            userId: -1,
            email: searchByEmail,
            lastName: '--',
            firstName: '--',
            accountId: -1,
            isDeleted: false,
        },
    };
};

export const shouldAddToMembers = (
    addedMembers: Array<AdminSearchInfo>,
    item: AdminSearchInfo,
    profileId: number,
): boolean => {
    return (item.currentProfile?.profileId ? item.currentProfile.profileId !== profileId : true)
        && !addedMembers.map(w => w.userInfo.email).includes(item.userInfo.email);
};

export const splitQuery = (query: string): Array<string> => {
    return [...new Set(query
        .replaceAll(/(?:\n)/g, ' ')
        .replaceAll(/(?:\t)/g, ' ')
        .replaceAll(/(?:\r)/g, ' ')
        .replaceAll(';', ' ')
        .replaceAll(',', ' ')
        .split(' ')
        .map(e => e.trim())
        .filter(e => e.length),
    )];
};
